import React, { useEffect, useState } from "react";
import "../style/gallerypage.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Images from "../images/gallery-photo1.jpg";
import Images2 from "../images/gallery-photo2.jpg";
import Images3 from "../images/gallery-photo3.jpg";
import Images4 from "../images/gallery-photo4.jpg";
import { FaArrowCircleRight, FaArrowCircleLeft } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import Footer from '../components/Footer';
import Infokontakt from '../components/Infokontakt';

function Gallerypage() {
  const [data, setData] = useState({ item: "", index: 0 });
  const viewImage = (item, index) => {
    setData({ item, index });
    document.body.style.overflow = "hidden";
  };
  const closeImage = () => {
    setData({ item: "", index: 0 });
    document.body.style.overflow = "auto";
  };
  const imgAction = (action) => {
    let index = data.index;
    if (action === "next-img" && index < imageGallery.length - 1) {
      setData({ item: imageGallery[index + 1].image, index: index + 1 });
    }
    if (action === "previues-img" && index > 0) {
      setData({ item: imageGallery[index - 1].image, index: index - 1 });
    }
    if (!action) {
      setData({ item: "", index: 0 });
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  const imageGallery = [
    { image: Images },
    { image: Images2 },
    { image: Images3 },
    { image: Images4 },
  ];

  return (
    <>
    <div className="div-gallaery-page">
      {data.item && (
        <div
          className="img-show"
          style={{
            width: "100%",
            height: "100vh",
            backgroundColor: "rgb(0,0,0,0.7",
            position: "fixed",
            top: 0,
            left: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            zIndex: "1",
          }}
        >
          <span
            className="exit-icon"
            onClick={closeImage}
            style={{ position: "absolute", top: "20px", right: "20px" }}
          >
            <MdCancel className="img-icon" />
          </span>
          <span onClick={() => imgAction("previues-img")}>
            <FaArrowCircleLeft className="img-icon" />
          </span>
          <LazyLoadImage
           data-aos="zoom-in"
           data-aos-offest="200"
           data-aos-duration="1000"
           data-aos-once="true"
            className="img-show-lazy"
            src={data.item}
            style={{
              width: "auto",
              maxWidth: "90%",
              maxHeight: "85%",
              marginBottom: "50px",
            }}
          />
          <span onClick={() => imgAction("next-img")}>
            <FaArrowCircleRight className="img-icon" />
          </span>
        </div>
      )}
      <div
        className="text-first-gallery"
        data-aos="zoom-in"
        data-aos-offest="200"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        <h2>Willkommen bei unseren Galerieprojekten</h2><br />
        <h3 style={{
          fontWeight:'300'
        }}>Bitte sehen Sie sich unser neuestes Projekt von unserem Unternehmen an.</h3>
      </div>

      <div className="gallery">
        {imageGallery.map((item, index) => (
          <div className="imagesSrc" key={index}>
            <LazyLoadImage
              onClick={() => viewImage(item.image, index)}
              data-aos="zoom-in"
              data-aos-offest="200"
              data-aos-duration="1000"
              data-aos-once="true"
              src={item.image}
              alt={`image ${index}`}
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
    <Infokontakt />
    <Footer />
    </>
  );
}

export default Gallerypage;
